module.exports = __webpack_public_path__ + "static/media/bin.d4e4e11a.png";